import React from 'react';
import AstraZenecaImg from '../../../imgs/AstraZeneca.gif';

export const AstraZeneca = ({hide, onClick}) => {
  return !hide && (
    <div
      style={{
        width: '300px',
        height: '250px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <img src={AstraZenecaImg} alt="AstraZenecaImg" />
      <a
        id="clickLayer"
        style={{
          position: 'absolute',
          left: '10px',
          width: '46px',
          cursor: 'pointer',
          bottom: '54px',
          height: '8px',
        }}
        onClick={onClick}
        href="https://www.medicines.ie/medicines/fluenz-nasal-spray-suspension-36276/spc"
        target="_blank"></a>
      <a
        id="clickLayer"
        style={{
          position: 'absolute',
          left: '10px',
          width: '122px',
          cursor: 'pointer',
          bottom: '38px',
          height: '15px',
        }}
        onClick={onClick}
        href="https://www.hiqa.ie/reports-and-publications/niac-immunisation-guideline/chapter-11-influenza"
        target="_blank"></a>
    </div>
  );
};
